import { getDefaultRedactionStatusSettings } from '@common-modules/mediaDetails/redactionStatuses';
import { RedactionStatusesState } from './models';

export const namespace = 'vtn-redact-state-redaction-statuses';

export const defaultState: RedactionStatusesState = {
  isFetchingStatuses: false,
  hasLoadedStatuses: false,
  hasPersistedStatusRecords: false,
  isSavingStatuses: false,
  redactionStatuses: getDefaultRedactionStatusSettings(),
  sdoIdsByStatus: {},
  customStatuses: [],
  isStatusDrawerOpen: false,
  selectedCustomStatus: undefined,
};

export interface RedactionStatusesStore {
  [namespace]: RedactionStatusesState;
}
